import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const SocialProof = () => {
  const testimonials = [
  {
    id: 1,
    name: 'Sarah Johnson',
    location: 'Seattle, WA',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1a9e8814c-1763296696290.png",
    avatarAlt: 'Professional woman with brown hair smiling at camera in business attire',
    rating: 5,
    text: `Vacuum Guide's review of the Dyson V15 was spot-on. After 6 months of use, everything they mentioned about pet hair performance is absolutely true. Saved me from making a costly mistake!`,
    product: 'Dyson V15 Detect',
    verified: true,
    timeAgo: '2 weeks ago'
  },
  {
    id: 2,
    name: 'Michael Chen', location: 'Austin, TX', avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_10ff39a65-1763293907590.png", avatarAlt: 'Asian man with glasses and friendly smile in casual shirt',
    rating: 5,
    text: `The buying guide helped me choose the perfect vacuum for my hardwood floors. The Shark Navigator they recommended has been fantastic for our 2-story home.`,
    product: 'Shark Navigator',
    verified: true,
    timeAgo: '1 month ago'
  },
  {
    id: 3,
    name: 'Emily Rodriguez', location: 'Miami, FL', avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_19c3040c9-1763301128250.png", avatarAlt: 'Hispanic woman with long dark hair smiling warmly outdoors', rating: 5, text: `Found an amazing deal through their deal tracker - saved $200 on a Bissell CrossWave! The detailed comparison charts made the decision so much easier.`, product: 'Bissell CrossWave',
    verified: true,
    timeAgo: '3 weeks ago'
  }];


  const stats = [
  {
    icon: 'Users',
    value: '2M+',
    label: 'Happy Customers',
    description: 'Homeowners trust our reviews'
  },
  {
    icon: 'Star',
    value: '500+',
    label: 'Products Tested',
    description: 'Comprehensive vacuum database'
  },
  {
    icon: 'Award',
    value: '4.9/5',
    label: 'User Rating',
    description: 'Based on 15K+ reviews'
  },
  {
    icon: 'DollarSign',
    value: '$50M+',
    label: 'Money Saved',
    description: 'Through smart recommendations'
  }];


  const trustBadges = [
  {
    icon: 'Shield',
    title: 'FTC Compliant',
    description: 'Transparent affiliate disclosures'
  },
  {
    icon: 'CheckCircle',
    title: 'Expert Tested',
    description: 'Real-world performance data'
  },
  {
    icon: 'Users',
    title: 'Community Verified',
    description: 'User reviews and feedback'
  },
  {
    icon: 'Zap',
    title: 'Updated Daily',
    description: 'Latest prices and deals'
  }];


  return (
    <section className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Stats Section */}
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Trusted by Millions
          </h2>
          <p className="text-xl text-gray-600 mb-12 max-w-3xl mx-auto">
            Join the community of smart shoppers who make informed decisions with our expert guidance.
          </p>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {stats?.map((stat, index) =>
            <div key={index} className="text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-4">
                  <Icon name={stat?.icon} size={32} className="text-primary" />
                </div>
                <div className="text-3xl lg:text-4xl font-bold text-gray-900 mb-2">
                  {stat?.value}
                </div>
                <div className="text-lg font-semibold text-gray-900 mb-1">
                  {stat?.label}
                </div>
                <div className="text-sm text-gray-600">
                  {stat?.description}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Testimonials Section */}
        <div className="mb-16">
          <div className="text-center mb-12">
            <h3 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-4">
              Real Success Stories
            </h3>
            <p className="text-lg text-gray-600">
              See how our recommendations have helped homeowners find their perfect vacuum.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials?.map((testimonial) =>
            <div
              key={testimonial?.id}
              className="bg-white rounded-xl shadow-subtle hover:shadow-floating transition-all duration-300 p-6">

                {/* Rating Stars */}
                <div className="flex items-center mb-4">
                  {[...Array(testimonial?.rating)]?.map((_, i) =>
                <Icon
                  key={i}
                  name="Star"
                  size={16}
                  className="text-yellow-500 fill-current" />

                )}
                </div>

                {/* Testimonial Text */}
                <blockquote className="text-gray-700 mb-6 leading-relaxed">
                  "{testimonial?.text}"
                </blockquote>

                {/* Product Mention */}
                <div className="bg-blue-50 rounded-lg p-3 mb-4">
                  <div className="flex items-center space-x-2">
                    <Icon name="Package" size={16} className="text-primary" />
                    <span className="text-sm font-medium text-primary">
                      Purchased: {testimonial?.product}
                    </span>
                  </div>
                </div>

                {/* User Info */}
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-3">
                    <Image
                    src={testimonial?.avatar}
                    alt={testimonial?.avatarAlt}
                    className="w-12 h-12 rounded-full object-cover" />

                    <div>
                      <div className="flex items-center space-x-2">
                        <span className="font-semibold text-gray-900">
                          {testimonial?.name}
                        </span>
                        {testimonial?.verified &&
                      <Icon name="BadgeCheck" size={16} className="text-blue-500" />
                      }
                      </div>
                      <div className="text-sm text-gray-500">
                        {testimonial?.location}
                      </div>
                    </div>
                  </div>
                  <div className="text-xs text-gray-400">
                    {testimonial?.timeAgo}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Trust Badges */}
        <div className="bg-white rounded-2xl shadow-subtle p-8">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-2">
              Why Trust Vacuum Guide?
            </h3>
            <p className="text-gray-600">
              Our commitment to transparency and accuracy sets us apart.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {trustBadges?.map((badge, index) =>
            <div key={index} className="text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-green-100 rounded-full mb-3">
                  <Icon name={badge?.icon} size={24} className="text-green-600" />
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">
                  {badge?.title}
                </h4>
                <p className="text-sm text-gray-600">
                  {badge?.description}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>);

};

export default SocialProof;